import { useMemo } from 'react';

import { useI18n } from '../../i18n';
import { JsonLd, SITE_ORIGIN, usePageMeta } from '../../lib/seo';
import AboutSection from '../components/AboutSection';
import FAQSection from '../components/FAQ';
import HeroSection from '../components/HeroSection';
import HowItWorksSection from '../components/HowItWorks';
import SectorsWeServeSection from '../components/SectorsWeServe';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUsSection from '../components/WhyChooseUs';

function Home() {
  const { t, language } = useI18n();

  usePageMeta({
    title: t.seo.home.title,
    description: t.seo.home.description,
  });

  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'MedHub',
        alternateName: t.hero.brandName,
        url: SITE_ORIGIN,
        logo: `${SITE_ORIGIN}/images/HospitalLogo.png`,
        address: {
          '@type': 'PostalAddress',
          addressCountry: 'SA',
        },
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: t.footer.phone.replace(/\s/g, ''),
          email: t.footer.email,
          contactType: 'customer service',
          areaServed: 'SA',
          availableLanguage: ['Arabic', 'English'],
        },
        parentOrganization: {
          '@type': 'Organization',
          name: 'Al Takassusi General Limited Company',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'MedHub',
        url: SITE_ORIGIN,
        inLanguage: language === 'ar' ? 'ar-SA' : 'en-US',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: t.faq.items.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ],
    [
      t.hero.brandName,
      t.footer.phone,
      t.footer.email,
      t.faq.items,
      language,
    ],
  );

  return (
    <>
      <JsonLd data={jsonLd} />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyChooseUsSection />
      <SectorsWeServeSection />
      <HowItWorksSection />
      <FAQSection />
    </>
  );
}

export default Home;
